module.exports = __webpack_public_path__ + "static/media/acms_bo.744f618e.svg";